import MessageListComponent from './component/MessageListComponent';
import { Nav } from 'react-bootstrap';
import './component/MessageListComponent.scss';

function MessagesList({ ListUser, selectedIndex, data = [] }) {
  return (
    <div>
      <div className="scroll">
        <Nav
          variant="pills"
          className="flex-column msggrpTabs message-mgt nav nav-pills"
        >
          {data.map((item, index) => (
            <MessageListComponent
              key={index}
              item={item}
              onClick={() => ListUser(index, item)}
              itemIndex={index}
              selectedIndex={selectedIndex}
            />
          ))}
        </Nav>
      </div>
    </div>
  );
}

export default MessagesList;
